import React, { use, useEffect, useState, useRef } from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils.js';
import { AppContext, useAppContext } from '../../contexts/AppContext.js';

const FavoriteIcon = ({product,className}) => {

    const { appRef } = useAppContext();
    const is_favorite = appRef.current.is_favorite_product(product);
    const class_name = className ?? 'fav';

    function handle_fav_click(e) {

        e.preventDefault();
        e.stopPropagation();

        if(is_favorite)
        {
            appRef.current.product_fav_delete(e,{product});
        }
        else
        {
            appRef.current.product_fav_add(e,{product});
        }

    }

    return <>
        <ReactSVG onClick={handle_fav_click} className={class_name} src={`/assets/images/${is_favorite ? 'favorites_on' : 'favorites_off'}.svg`}></ReactSVG>
    </>
}

export default FavoriteIcon;